import { useState } from 'react';
import StatusTracker from './StatusTracker';

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  el?.scrollIntoView({ behavior: 'smooth' });
};

function Topbar({ isNavOpen, onToggleNav }) {
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  
  const handleClick = (sectionId) => {
    scrollToSection(sectionId);
    onToggleNav(false);
  };

  return (
    <header className="topbar">
      <button
        type="button"
        className="brand brand-clickable"
        onClick={() => scrollToSection('features')}
      >
        <img src="/logo.webp" alt="Premium Online Training" className="logo-image" />
      </button>
      <button
        type="button"
        className="nav-toggle"
        onClick={onToggleNav}
        aria-label="Toggle navigation menu"
      >
        ☰
      </button>
      <nav className={`nav-links ${isNavOpen ? 'open' : ''}`}>
        <button type="button" className="link-btn" onClick={() => handleClick('plans')}>
          Plans
        </button>
        <button type="button" className="link-btn" onClick={() => handleClick('testimonials')}>
          Testimonials
        </button>
        <button type="button" className="link-btn" onClick={() => handleClick('faq')}>
          FAQ
        </button>
        <div className="topbar-actions">
          <button
            type="button"
            className="link-btn"
            onClick={() => {
              setIsStatusModalOpen(true);
              onToggleNav(false);
            }}
          >
            Track Status
          </button>
          <button
            className="primary"
            onClick={() => {
              scrollToSection('contact');
              onToggleNav(false);
            }}
          >
            Get Started
          </button>
        </div>
      </nav>
      <div className="topbar-actions">
        <button
          type="button"
          className="link-btn"
          onClick={() => setIsStatusModalOpen(true)}
        >
          Track Status
        </button>
        <button className="primary" onClick={() => scrollToSection('contact')}>
          Get Started
        </button>
      </div>
      <StatusTracker isOpen={isStatusModalOpen} onClose={() => setIsStatusModalOpen(false)} />
    </header>
  );
}

export default Topbar;


